import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
var SkeletonStyled = styled.div.withConfig({
    displayName: "SkeletonTable__SkeletonStyled",
    componentId: "sc-1kafb89-0"
})([
    "background:#ffffff;padding:20px 10px;table{width:100%;padding:20px 0;table-layout:fixed;td,th{padding:5px;}}"
]);
export default function SkeletonTable(param) {
    var hideHeader = param.hideHeader, rows = param.rows, columns = param.columns, height = param.height;
    return(/*#__PURE__*/ _jsx(SkeletonStyled, {
        className: "skelenton",
        children: /*#__PURE__*/ _jsxs("table", {
            children: [
                !hideHeader && /*#__PURE__*/ _jsx("thead", {
                    children: /*#__PURE__*/ _jsx("tr", {
                        children: /*#__PURE__*/ _jsx("th", {
                            colSpan: columns || 5,
                            children: /*#__PURE__*/ _jsx(Skeleton, {
                                height: height || 30,
                                width: "100%"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("tbody", {
                    children: new Array(rows || 5).fill(1).map(function(_, index1) {
                        /*#__PURE__*/ return _jsx("tr", {
                            children: new Array(columns || 5).fill(1).map(function(_, index) {
                                /*#__PURE__*/ return _jsx("td", {
                                    children: /*#__PURE__*/ _jsx(Skeleton, {
                                        height: height || 25
                                    })
                                }, index);
                            })
                        }, index1);
                    })
                })
            ]
        })
    }));
};
